import React, { useState } from 'react';
import { Send, Phone, Video } from 'lucide-react';
import MessageList from './MessageList';
import ChatInput from './ChatInput';

const ChatWindow = ({ user }) => {
  const [messages, setMessages] = useState([]);

  const handleSendMessage = (content) => {
    const newMessage = {
      id: Date.now().toString(),
      content,
      sender: 'me',
      timestamp: new Date().toISOString(),
    };
    setMessages([...messages, newMessage]);
  };

  return (
    <div className="flex-1 flex flex-col">
      <div className="p-4 border-b border-gray-200 flex justify-between items-center">
        <div className="flex items-center space-x-3">
          <img
            src={user.avatar}
            alt={user.name}
            className="w-10 h-10 rounded-full"
          />
          <div>
            <h3 className="font-medium text-gray-900">{user.name}</h3>
            <p className="text-sm text-gray-500">{user.status}</p>
          </div>
        </div>
        <div className="flex space-x-2">
          <button className="p-2 text-gray-500 hover:text-gray-700 rounded-full hover:bg-gray-100">
            <Phone className="w-5 h-5" />
          </button>
          <button className="p-2 text-gray-500 hover:text-gray-700 rounded-full hover:bg-gray-100">
            <Video className="w-5 h-5" />
          </button>
        </div>
      </div>
      <MessageList messages={messages} />
      <ChatInput onSendMessage={handleSendMessage} />
    </div>
  );
};

export default ChatWindow;
